// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgramPage_diet_container__2Unlh","gradient":"ProgramPage_diet_gradient__2Acbw"};